export default __webpack_public_path__ + "static/media/381.574338c4.jpg";